import axiosInstance from '../../config/axios';
import Swal from "sweetalert2";
import React, { useContext, useState, useEffect } from "react";
import Input from "@material-tailwind/react/Input";
import { RootContext } from '../../App';
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Card from "@material-tailwind/react/Card";
import CardBody from "@material-tailwind/react/CardBody";
import refactorStructureData from '../../helpers/refactorDataMenu';
import CardHeader from "@material-tailwind/react/CardHeader";
import Button from "@material-tailwind/react/Button";
import ReactLoading from "react-loading";

export default function ReferralV2Settings() {
  const [listData, setListData] = useState(null);
  const [turnoverComission, setTurnoverComission] = useState("");
  const [winloseComission, setWinloseComission] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const { state, setState } = useContext(RootContext);
  const history = useHistory();

  const validateInput = (value) => {
    // Allow empty string for initial state
    if (value === "") return true;
    
    // Check if it's a valid number between 0 and 100 with up to 2 decimal places
    const regex = /^(100(\.0{1,2})?|[0-9]{1,2}(\.[0-9]{1,2})?)$/;
    return regex.test(value);
  };

  const handleTurnoverChange = (e) => {
    const value = e.target.value;
    if (validateInput(value)) {
      setTurnoverComission(value);
    }
  };

  const handleWinloseChange = (e) => {
    const value = e.target.value;
    if (validateInput(value)) {
      setWinloseComission(value);
    }
  };

  const handleSave = () => {
    // Additional validation before saving
    if (!validateInput(turnoverComission) || !validateInput(winloseComission)) {
      Swal.fire(
        'Validation Error',
        'Commission values must be between 0.00 and 100.00',
        'error'
      );
      return;
    }

    setIsSaving(true);
    const token = localStorage.getItem("access_token");
    const group = JSON.parse(localStorage.getItem("group"));

    const data = {
      token: token,
      group: group.wbid,
      turnover_comision: parseFloat(turnoverComission),
      winlose_comision: parseFloat(winloseComission)
    };

    axiosInstance('set_referral_comission', {
      method: "POST",
      data,
    }).then((res) => {
      setIsSaving(false);
      
      if (res.data.code === 0) {
        Swal.fire(
          'Success',
          'Referral commission settings have been updated',
          'success'
        );
      } else {
        Swal.fire(
          'Error',
          res.data.message || 'Failed to update settings',
          'error'
        );
      }
    }).catch((err) => {
      setIsSaving(false);
      
      if (err.response && err.response.status === 401) {
        Swal.fire(
          'Session Expired',
          'Your session has expired. Please log in again.',
          'warning'
        ).then(() => {
          localStorage.removeItem("access_token");
          history.push("/login");
        });
      } else {
        Swal.fire(
          'Error',
          err.response?.data?.message || 'Something went wrong',
          'error'
        );
      }
    });
  };

  const fetchData = () => {
    setIsLoading(true);
    const token = localStorage.getItem("access_token");
    const group = JSON.parse(localStorage.getItem("group"));

    if (!token) {
      history.push("/login");
      return;
    }

    axiosInstance('get_referral_comission', {
      method: "POST",
      data: {
        token: token,
        group: group.wbid
      },
    }).then((res) => {
      setIsLoading(false);
      if (res.data.code === 0) {
        const data = res.data.data.list;
        setListData(data);
        setTurnoverComission(data.turnover_comision.toString());
        setWinloseComission(data.winlose_comision.toString());
        
        setState({
          ...state,
          group: res.data.data.additional_data.group,
          menu: refactorStructureData(res.data.data.additional_data.menu),
        });
      } else {
        Swal.fire(
          'Error',
          res.data.message || 'Failed to fetch settings',
          'error'
        );
      }
    }).catch((err) => {
      setIsLoading(false);
      
      if (err.response && err.response.status === 401) {
        Swal.fire(
          'Session Expired',
          'Your session has expired. Please log in again.',
          'warning'
        ).then(() => {
          localStorage.removeItem("access_token");
          history.push("/login");
        });
      } else {
        Swal.fire(
          'Error',
          err.response?.data?.message || 'Something went wrong',
          'error'
        );
      }
    });
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="bg-light-blue-500 pt-7 pb-28 px-3 md:px-8 h-auto"></div>
      <div className="px-3 md:px-8 h-auto -mt-24">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4 mb-16">
            {isLoading ? (
              <div className="flex justify-center" style={{ marginTop: 150 }}>
                <ReactLoading
                  type="spinningBubbles"
                  color="rgb(53, 126, 221)"
                  height={100}
                  width={100}
                />
              </div>
            ) : (
              <Card>
                <CardHeader color="blueGray" contentPosition="none">
                  <div className="w-full flex items-center justify-between">
                    <h2 className="text-white text-2xl">Referral Commission Settings</h2>
                  </div>
                </CardHeader>
                <CardBody>
                  <div>
                    <h6 className="text-purple-500 text-sm my-6 font-light uppercase">
                      Turnover Commission Percentage
                    </h6>
                    <div className="flex flex-wrap mt-10 font-light">
                      <div className="w-full lg:w-6/12 pr-4 mb-10 font-light">
                        <Input
                          type="number"
                          color="purple"
                          placeholder="Turnover Commission (%)"
                          value={turnoverComission}
                          onChange={handleTurnoverChange}
                          min="0"
                          max="100"
                          step="0.01"
                        />
                        <p className="text-xs text-gray-500 mt-1">
                          Enter a value between 0.00 and 100.00
                        </p>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h6 className="text-purple-500 text-sm my-6 font-light uppercase">
                      Winlose Commission Percentage
                    </h6>
                    <div className="flex flex-wrap mt-10 font-light">
                      <div className="w-full lg:w-6/12 pr-4 mb-10 font-light">
                        <Input
                          type="number"
                          color="purple"
                          placeholder="Winlose Commission (%)"
                          value={winloseComission}
                          onChange={handleWinloseChange}
                          min="0"
                          max="100"
                          step="0.01"
                        />
                        <p className="text-xs text-gray-500 mt-1">
                          Enter a value between 0.00 and 100.00
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-start mt-6">
                    <Button
                      color="lightBlue"
                      buttonType="filled"
                      size="regular"
                      rounded={false}
                      block={false}
                      iconOnly={false}
                      ripple="light"
                      onClick={handleSave}
                      disabled={isSaving}
                    >
                      {isSaving ? "Saving..." : "Save Changes"}
                    </Button>
                  </div>
                </CardBody>
              </Card>
            )}
          </div>
        </div>
      </div>
    </>
  );
}